



















import Vue, { PropType } from 'vue'
import CheckBoxesAgrupados from 'src/typescript/common/CheckBoxes/CheckBoxesAgrupados'

import {ICheckBoxesAgrupados, ICheckBoxesAgrupadosSecoes} from 'src/tipos/CheckBoxesAgrupados'
import { resgatarListaDeChavesDosCheckBoxesAgrupadosPorSecao, resgatarListaDeChavesDosCheckBoxesAgrupados } from 'src/typescript/common/CheckBoxes/utils'

interface Methods {
  resgatarListaDeChavesDosCheckBoxesAgrupados: (opcoes: ICheckBoxesAgrupados) => string[];
}

interface Props {
  value: string[];
  secoes: ICheckBoxesAgrupadosSecoes;
  legenda?: string;
}

interface Computed {
  itensInternos: ICheckBoxesAgrupadosSecoes;
}

export default Vue.extend<{}, Methods, Computed, Props>({
  name: 'CheckBoxesAgrupadosSecoes',

  components: {CheckBoxesAgrupados},

  props: {
    value: {
      type: Array as PropType<string[]>,
      required: true
    },

    secoes: {
      type: Object,
      required: true
    },

    legenda: {
      type: String,
      required: false
    }
  },

  computed: {
    itensInternos (): ICheckBoxesAgrupadosSecoes {
      return this.secoes
    }
  },

  methods: {
    resgatarListaDeChavesDosCheckBoxesAgrupados (opcoes: ICheckBoxesAgrupados): string[] {
      return resgatarListaDeChavesDosCheckBoxesAgrupados(opcoes)
    }
  },

  watch: {
    itensInternos: {
      deep: true,
      handler (opcoesNovas: ICheckBoxesAgrupadosSecoes): void {
        const listaDeChavesMarcadas = resgatarListaDeChavesDosCheckBoxesAgrupadosPorSecao(opcoesNovas)
        this.$emit('input', listaDeChavesMarcadas)
      }
    }
  }
})
